import moment from 'moment';
import { useTheme } from 'styled-components';

import SearchBarSingleDatePickerInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarSingleDatePickerInput/SearchBarSingleDatePickerInput';
import { SearchBarInputError } from '@components/views/flight/types';
import { DayPickerSingleDateControllerProps } from '@components/DatePicker/SingleDatePicker/SingleDatePicker';
import {
  SearchBarInputProps,
  SearchBarPopoverProps,
} from '@components/ui/search/SearchBarInput/SearchBarInputInterface';

export interface SearchBarSingleDatePickerProps
  extends Pick<
      DayPickerSingleDateControllerProps,
      'date' | 'onDateChange' | 'onReady'
    >,
    Pick<SearchBarInputProps, 'popoverContentReady'> {
  error?: SearchBarInputError | boolean;
  label?: string;
  placeholder: string;
  popoverProps?: SearchBarPopoverProps;
  inputComponent:
    | 'shopAndFlyHomePageCarRental'
    | 'shopAndFlyHomePageFlight'
    | 'shopAndFlyHomePageHotel'
    | 'setur';
}

const SearchBarSingleDatePicker = ({
  date,
  onDateChange,
  error,
  inputComponent,
  label,
  placeholder,
  onReady,
  popoverContentReady,
  popoverProps,
}: SearchBarSingleDatePickerProps) => {
  const theme = useTheme();
  const { containerStyle, ...otherPopoverProps } = popoverProps ?? {};

  return (
    <SearchBarSingleDatePickerInput
      placeholder={placeholder}
      label={label}
      error={Boolean(error)}
      dateProps={{
        date: date ? moment(date) : null,
        onDateChange,
        onReady,
      }}
      inputComponent={inputComponent}
      popoverContentReady={popoverContentReady}
      popoverProps={{
        ...otherPopoverProps,
        containerStyle: {
          width: '620px',
          zIndex: String(theme.zIndices.timePicker),
          ...containerStyle,
        },
      }}
    />
  );
};

export { SearchBarSingleDatePicker };
